<template>
    <Default-Layout>
        <div class="container profile">
            <div class="row">
                <div class="col-12">
                    <div class="prof_title">
                        <h4>{{ $t("lang.label_crte_accts") }}</h4>
                        <p style="text-align: center">
                            {{ $t("lang.label_crte_accts_managt") }}
                        </p>
                    </div>
                    <div class="card" style="border-top: 4px solid #a1e0ae">
                        <div class="icontri"></div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5 class="card-title">
                                        {{ titleFrom }} {{ $t("lang.label_user") }}
                                    </h5>
                                    <form
                                        @submit.prevent="saveUsers"
                                        enctype="multipart/form-data"
                                    >
                                        <div class="form-row">
                                            <div class="form-group col-md-4 text-center">
                                                <label for="">Avatar</label>
                                                <div v-if="viewAvatar">
                                                    <div v-if="imgAvatar">
                                                        <img
                                                            v-bind:src="avatar"
                                                            id="avatar"
                                                        />
                                                    </div>
                                                    <div v-else>
                                                        <span
                                                            class="avatarDefault"
                                                            @click="$refs.avatar.click()"
                                                            >{{ avatarDefault }}</span
                                                        >
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <i
                                                        class="fas fa-user-circle fa-5x"
                                                        @click="$refs.avatar.click()"
                                                    ></i>
                                                </div>
                                                <button
                                                    v-if="btnDeleteImg"
                                                    type="button"
                                                    class="btn btn-danger"
                                                    style="
                                                        padding: 2px 5px;
                                                        margin-top: 10px;
                                                    "
                                                    @click="delAvatar"
                                                >
                                                    <i class="fas fa-trash"></i>
                                                    {{ $t("lang.label_del") }}
                                                </button>
                                                <button
                                                    v-else
                                                    type="button"
                                                    class="btn btn-success"
                                                    style="
                                                        padding: 2px 5px;
                                                        margin-top: 10px;
                                                    "
                                                    @click="$refs.avatar.click()"
                                                >
                                                    <i class="fas fa-upload"></i>
                                                    {{ $t("lang.label_up") }}
                                                </button>
                                                <input
                                                    type="file"
                                                    style="display: none"
                                                    ref="avatar"
                                                    accept="image/*"
                                                    @change="fileImg"
                                                />
                                            </div>
                                            <div class="col-md-8">
                                                <div class="form-group">
                                                    <label for="">{{
                                                        $t("lang.label_fname")
                                                    }}</label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="firstname"
                                                        required
                                                    />
                                                </div>
                                                <div class="form-group">
                                                    <label for="">{{
                                                        $t("lang.label_lname")
                                                    }}</label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="lastname"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="">{{
                                                $t("lang.msj_email")
                                            }}</label>
                                            <input
                                                type="email"
                                                class="form-control"
                                                v-model="email"
                                                required
                                            />
                                        </div>
                                        <div class="form-group">
                                            <label
                                                for=""
                                                style="
                                                    display: flex;
                                                    justify-content: space-between;
                                                "
                                                ><span>{{ $t("lang.label_pass") }}</span>
                                                <span
                                                    style="
                                                        color: #6ba6d0;
                                                        cursor: pointer;
                                                    "
                                                    v-if="action === 'update'"
                                                    @click="activePassword"
                                                    >{{
                                                        $t("lang.label_change_pass")
                                                    }}</span
                                                ></label
                                            >
                                            <input
                                                type="password"
                                                class="form-control"
                                                v-model="password"
                                                required
                                                v-if="action === 'update'"
                                                :disabled="disabled"
                                            />
                                            <input
                                                type="password"
                                                class="form-control"
                                                v-model="password"
                                                required
                                                v-if="action === 'create'"
                                            />
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-md-6">
                                                <label for="inputCity">{{
                                                    $t("lang.msj_status")
                                                }}</label>
                                                <select
                                                    class="custom-select"
                                                    v-model="status"
                                                >
                                                    <option value="1">
                                                        {{ $t("lang.msj_active") }}
                                                    </option>
                                                    <option value="0">
                                                        {{ $t("lang.msj_inactive") }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label for="inputCity">{{
                                                    $t("lang.label_adress")
                                                }}</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="address"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-md-6">
                                                <label for="inputCity">{{
                                                    $t("lang.label_city")
                                                }}</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="city"
                                                />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label for="inputCity">{{
                                                    $t("lang.label_state")
                                                }}</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="state"
                                                />
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-md-6">
                                                <label for="">{{
                                                    $t("lang.label_zip")
                                                }}</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="zip_code"
                                                />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label for="">{{
                                                    $t("lang.label_telephone")
                                                }}</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="telephone"
                                                />
                                            </div>
                                        </div>
                                        <button
                                            type="button"
                                            class="btn btn-light float-left"
                                            @click="clearForm"
                                            style="border: 1px solid #ccc"
                                        >
                                            {{ $t("lang.label_cancel") }}
                                        </button>
                                        <button
                                            type="submit"
                                            class="btn btn-success float-right"
                                        >
                                            {{ btnAction }}
                                        </button>
                                    </form>
                                </div>
                                <div class="col-md-7">
                                    <div style="padding-left: 20px">
                                        <h5 class="card-title">
                                            {{ $t("lang.msj_users_lst") }}
                                        </h5>
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th scope="col">
                                                        {{ $t("lang.label_fname") }}
                                                    </th>
                                                    <th scope="col">
                                                        {{ $t("lang.label_lname") }}
                                                    </th>
                                                    <th scope="col">
                                                        {{ $t("lang.msj_email") }}
                                                    </th>
                                                    <th scope="col">
                                                        {{ $t("lang.msj_status") }}
                                                    </th>
                                                    <th scope="col">
                                                        {{ $t("lang.label_org") }}
                                                    </th>
                                                    <th scope="col">
                                                        {{ $t("lang.label_action") }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(i, index) in userlist"
                                                    :key="index"
                                                >
                                                    <td>{{ i.firstname }}</td>
                                                    <td>{{ i.lastname }}</td>
                                                    <td>{{ i.email }}</td>
                                                    <td>
                                                        <span
                                                            v-if="i.status == 1"
                                                            class="badge badge-success"
                                                            >{{
                                                                $t("lang.msj_active")
                                                            }}</span
                                                        >
                                                        <span
                                                            v-else
                                                            class="badge badge-secondary"
                                                            >{{
                                                                $t("lang.msj_inactive")
                                                            }}</span
                                                        >
                                                    </td>
                                                    <td>
                                                        <span
                                                            class="badge badge-light"
                                                            style="font-size: 14px"
                                                            >{{ i.cant_org }}</span
                                                        >
                                                    </td>
                                                    <td>
                                                        <span class="cdropdown">
                                                            <button>
                                                                <span>{{
                                                                    $t(
                                                                        "lang.label_action"
                                                                    )
                                                                }}</span>
                                                            </button>
                                                            <label>
                                                                <input type="checkbox" />
                                                                <ul>
                                                                    <!--  <li @click="actionAssignOrg(i.account_id,i.org_id,i.list_org)"><button><i class="fas fa-cog"></i> Assign Org</button></li> -->
                                                                    <li
                                                                        @click="
                                                                            AssignPrivilegies(
                                                                                i.account_id
                                                                            )
                                                                        "
                                                                    >
                                                                        <button>
                                                                            <i
                                                                                class="fas fa-cog"
                                                                            ></i>
                                                                            {{
                                                                                $t(
                                                                                    "lang.label_edit_priv"
                                                                                )
                                                                            }}
                                                                        </button>
                                                                    </li>
                                                                    <li
                                                                        @click="
                                                                            actionEdit(
                                                                                i.account_id,
                                                                                i
                                                                            )
                                                                        "
                                                                    >
                                                                        <button>
                                                                            <i
                                                                                class="fas fa-edit"
                                                                            ></i>
                                                                            {{
                                                                                $t(
                                                                                    "lang.label_edit_prof"
                                                                                )
                                                                            }}
                                                                        </button>
                                                                    </li>
                                                                    <li
                                                                        @click="
                                                                            MetDelete(
                                                                                i.account_id
                                                                            )
                                                                        "
                                                                    >
                                                                        <button>
                                                                            <i
                                                                                class="fas fa-times"
                                                                            ></i>
                                                                            {{
                                                                                $t(
                                                                                    "lang.label_del"
                                                                                )
                                                                            }}
                                                                        </button>
                                                                    </li>
                                                                </ul>
                                                            </label>
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal
            name="org-assign"
            height="auto"
            :width="600"
            @before-close="getOrganizations"
        >
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">{{ $t("lang.label_asgn_org") }}</h5>
                    <form @submit.prevent="MetAssignOrg">
                        <div class="row">
                            <div class="col-10">
                                <label for="inputEmail4">{{
                                    $t("lang.label_name_org")
                                }}</label>
                                <select
                                    id="inputState"
                                    class="form-control"
                                    v-model="modal.org_id"
                                >
                                    <option
                                        :value="i.id"
                                        v-for="i in orgsDisponibles"
                                        :key="i.id"
                                    >
                                        {{ i.bill_company_name }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-2">
                                <label for="inputEmail4" style="display: block"
                                    ><span style="color: #5198d4">{{
                                        $t("lang.label_asgn")
                                    }}</span></label
                                >
                                <button class="btn btn-success" type="submit">
                                    {{ $t("lang.label_save") }}
                                </button>
                            </div>
                        </div>
                    </form>
                    <div style="padding-top: 20px; margin-bottom: 80px">
                        <hr />
                        <h5 class="card-title">{{ $t("lang.label_lst_asgnd_org") }}</h5>
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col" width="80%">
                                        {{ $t("lang.label_org") }}
                                    </th>
                                    <th scope="col">{{ $t("lang.msj_status") }}</th>
                                    <th scope="col">{{ $t("lang.label_active") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(i, index) in orgsAssign" :key="index">
                                    <td width="80%">{{ i.nom }}</td>
                                    <td>
                                        <span
                                            v-if="i.status == 1"
                                            class="badge badge-success"
                                            >{{ $t("lang.label_active") }}</span
                                        >
                                        <span v-else class="badge badge-secondary">{{
                                            $t("lang.label_inactive")
                                        }}</span>
                                    </td>
                                    <td>
                                        <span class="cdropdown">
                                            <button>
                                                <span><i class="fa fa-cog"></i></span>
                                            </button>
                                            <label>
                                                <input type="checkbox" />
                                                <ul>
                                                    <li
                                                        @click="
                                                            privilegesOrg(
                                                                i.id,
                                                                i.accoun_id
                                                            )
                                                        "
                                                    >
                                                        <button>
                                                            <i class="fas fa-edit"></i>
                                                            {{ $t("lang.label_priv") }}
                                                        </button>
                                                    </li>
                                                    <li
                                                        @click="delOrg(i.id, i.accoun_id)"
                                                    >
                                                        <button>
                                                            <i class="fas fa-times"></i>
                                                            {{ $t("lang.label_del") }}
                                                        </button>
                                                    </li>
                                                </ul>
                                            </label>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </modal>
    </Default-Layout>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import DefaultLayout from "@/Layouts/Account/DefaultLayout";
export default {
    name: "Profile",
    components: {
        DefaultLayout,
    },
    data () {
        return {
            isloaing: false,
            viewAvatar: false,
            imgAvatar: false,
            validimg: false,
            btnDeleteImg: false,
            avatarDefault: false,
            borrarAvatar: false,
            avatar_old: "",
            user_id: window.localAccountID,
            action: "create",
            btnAction: window.lang2.label_add,
            titleFrom: window.lang2.label_new,
            id: null,
            account_id: null,
            firstname: "",
            lastname: "",
            email: "",
            password: "",
            address: "",
            city: "",
            state: "",
            zip_code: "",
            telephone: "",
            avatar: "",
            status: 1,
            userlist: [],
            disabled: true,
            changepassword: false,
            organizationslist: [],
            orgsDisponibles: [],
            orgsAssign: [],
            modal: {
                action: "create",
                org_id: window.localorgdata,
                user_id_secondary: null,
            },
        }
    },
    created () {
        if (window.user_type == 2) {
            this.$router.push({ name: "Home" });
        }
        this.userslist();
        this.getOrganizations();
    },
    methods: {
        AssignPrivilegies(account_id) {
            const userId = account_id;
            this.$router.push({ name: "Privilegies", params: { account_id: userId } });
        },
        MetAssignOrg() {
            if (this.modal.action == "create") {
                window.master
                    .post("user/assignorg", {
                        user_id: window.localAccountID,
                        org_id: this.modal.org_id,
                        user_id_secondary: this.modal.user_id_secondary,
                    })
                    .then((response) => {
                        this.userslist();
                        this.$modal.hide("org-assign");

                        if (response.data.status) {
                            this.$swal.fire({
                                type: "success",
                                title: window.lang2.msj_crte_user_sful,
                                showConfirmButton: false,
                                timer: 2000,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else if (this.action == "update") {
                window.master
                    .put("user/update", {
                        user_id: window.localAccountID,
                        id: this.id,
                        account_id: this.account_id,
                    })
                    .then((response) => {
                        this.isloaing = false;
                        if (response.data.status) {
                            this.$swal.fire({
                                type: "success",
                                title: window.lang2.msj_upd_sful,
                                showConfirmButton: false,
                                timer: 2000,
                            });
                        }
                    })
                    .catch((error) => console.log(error, (this.isloaing = false)));
            }
        },
        getOrganizations() {
            this.isloaing = true;
            window.master
                .get("organizationall/" + window.localAccountID)
                .then((response) => {
                    console.log(response.data);
                    this.organizationslist = response.data.result;
                    this.isloaing = false;
                })
                .catch((error) => console.log(error));
        },
        activePassword() {
            this.changepassword = !this.changepassword;
            this.password = null;
            this.disabled = !this.disabled;
        },
        actionAssignOrg(iduser, org_id, list_org) {
            //if(org_id !== 0){
            //  this.modal.org_id = org_id
            //}
            console.log("orgsAssign", list_org);
            console.log("entrada organizationslist", this.organizationslist);
            this.orgsAssign = [];
            let listOrs = this.organizationslist;
            this.orgsDisponibles = listOrs;
            if (list_org.length > 0) {
                for (let i in list_org) {
                    //agregando asignados
                    for (let k in listOrs) {
                        if (list_org[i].org_id == listOrs[k].id) {
                            console.log("agregando=" + listOrs[k].id);
                            this.orgsAssign.push({
                                id: listOrs[k].id,
                                nom: listOrs[k].bill_company_name,
                                status: listOrs[k].status,
                                accoun_id: list_org[i].user_id_secondary,
                            });
                        }
                    }
                    // eliminando item asignados
                    for (let e in this.orgsDisponibles) {
                        if (list_org[i].org_id == this.orgsDisponibles[e].id) {
                            this.orgsDisponibles.splice(e, 1);
                        }
                    }
                }
            }
            console.log("orgsDisponibles", this.orgsDisponibles);
            console.log("salida organizationslist", this.organizationslist);
            this.modal.org_id = this.orgsDisponibles[0].id; // asignando 1er option
            this.modal.user_id_secondary = iduser;
            this.$modal.show("org-assign");
        },
        privilegesOrg(id, accoun_id) {},
        delOrg(id, accoun_id) {},
        actionEdit(id, i) {
            console.log("account_id=" + id + " array=", i);
            this.action = "update";
            this.btnAction = window.lang2.label_save;
            this.titleFrom = window.lang2.label_edit;
            this.viewAvatar = true;
            this.avatar = i.ruta + i.avatar;
            this.avatar_old = i.avatar;
            this.imgAvatar = i.imgAvatar;
            this.btnDeleteImg = i.imgAvatar;
            this.id = i.id;
            this.account_id = i.account_id;
            this.firstname = i.firstname;
            this.lastname = i.lastname;
            this.email = i.email;
            this.password = "********";
            this.address = i.address;
            this.city = i.city;
            this.state = i.state;
            this.zip_code = i.zip_code;
            this.telephone = i.telephone;
            this.status = i.status;
        },
        MetDelete(id) {
            window.master
                .get("user/delete/" + id + "/" + window.localAccountID)
                .then((response) => {
                    console.log(response.data);
                    if (response.data.status) {
                        this.userslist();
                        this.$swal.fire({
                            type: "success",
                            title: window.lang2.label_deld,
                            showConfirmButton: false,
                            timer: 2000,
                        });
                    }
                })
                .catch((error) => console.log(error));
        },
        userslist() {
            window.master
                .get("users/" + window.localAccountID)
                .then((response) => {
                    console.log(response.data);
                    this.userlist = response.data.result;
                    this.isloaing = false;
                })
                .catch((error) => console.log(error));
        },
        saveUsers() {
            console.log("save ", this.action);
            var f = new FormData();
            f.append("user_id", window.localAccountID);
            f.append("id", this.id);
            f.append("account_id", this.account_id);
            f.append("firstname", this.firstname);
            f.append("lastname", this.lastname);
            f.append("email", this.email);
            f.append("password", this.password);
            f.append("changepassword", this.changepassword);
            f.append("address", this.address);
            f.append("city", this.city);
            f.append("state", this.state);
            f.append("zip_code", this.zip_code);
            f.append("telephone", this.telephone);
            f.append("status", this.status);
            f.append("avatar_old", this.avatar_old);
            f.append("borrarAvatar", this.borrarAvatar);
            f.append("validimg", this.validimg);
            if (this.validimg == true) {
                f.append(
                    "avatar",
                    event.target.elements[1].files[0],
                    event.target.elements[1].files.name
                );
            }
            if (this.action == "create") {
                window.master
                    .post("/user/add", f)
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal.fire({
                                type: "success",
                                title: window.lang2.msj_crte_user_sful,
                                showConfirmButton: false,
                                timer: 2000,
                            });
                            this.clearForm();
                            this.userslist();
                        } else {
                            this.$swal.fire({
                                type: "error",
                                title: "Error",
                                text: window.lang2.msj_email_exists,
                                showCloseButton: true,
                                cancelButtonColor: "#d33",
                                cancelButtonText: window.lang2.label_close,
                                timer: 5000,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else if (this.action == "update") {
                window.master
                    .post("user/update", f)
                    .then((response) => {
                        console.log("update ok");
                        console.log(response.data);
                        this.isloaing = false;
                        if (response.data.status) {
                            this.clearForm();
                            this.userslist();
                            this.$swal.fire({
                                type: "success",
                                title: window.lang2.msj_upd_sful,
                                showConfirmButton: false,
                                timer: 2000,
                            });
                        }
                    })
                    .catch((error) => console.log(error, (this.isloaing = false)));
            }
        },
        clearForm() {
            this.action = "create";
            this.btnAction = window.lang2.label_add;
            this.titleFrom = window.lang2.label_new;
            this.id = null;
            this.account_id = null;
            this.firstname = null;
            this.lastname = null;
            this.email = null;
            this.password = null;
            this.address = null;
            this.city = null;
            this.state = null;
            this.zip_code = null;
            this.telephone = null;
            this.changepassword = false;
            this.avatar = null;
            this.status = 1;
            this.validimg = false;
            this.viewAvatar = false;
            this.imgAvatar = false;
            this.btnDeleteImg = false;
            this.borrarAvatar = false;
        },
        fileImg(event) {
            this.validimg = true;
            this.viewAvatar = true;
            this.imgAvatar = true;
            this.btnDeleteImg = true;
            if (event.target.files.length > 0) {
                var reader = new FileReader();
                reader.readAsDataURL(event.target.files[0]);
                reader.onload = function (e) {
                    document.querySelector("#avatar").src = e.target.result;
                };
            }
            this.validAvatarDefault();
        },
        delAvatar() {
            this.imgAvatar = false;
            this.validimg = false;
            this.btnDeleteImg = false;
            this.borrarAvatar = true;
            this.avatar = "";
            this.$refs.avatar.value = "";
            this.validAvatarDefault();
        },
        validAvatarDefault() {
            if (!this.validimg) {
                if (
                    this.firstname != null &&
                    this.firstname.length > 0 &&
                    this.lastname != null &&
                    this.lastname.length > 0 &&
                    !this.imgAvatar
                ) {
                    this.viewAvatar = true;
                    this.avatarDefault =
                        this.firstname.charAt().toUpperCase() +
                        this.lastname.charAt().toUpperCase();
                } else if (
                    this.firstname != null &&
                    this.firstname.length > 0 &&
                    !this.imgAvatar
                ) {
                    this.viewAvatar = true;
                    this.avatarDefault = this.firstname.charAt().toUpperCase();
                } else if (
                    this.lastname != null &&
                    this.lastname.length > 0 &&
                    !this.imgAvatar
                ) {
                    this.viewAvatar = true;
                    this.avatarDefault = this.lastname.charAt().toUpperCase();
                } else if (this.imgAvatar) {
                    this.viewAvatar = true;
                } else {
                    this.viewAvatar = false;
                }
            }
        },
    },
    watch: {
        firstname() {
            if (!this.validimg) {
                if (
                    this.firstname != null &&
                    this.firstname.length > 0 &&
                    this.lastname != null &&
                    this.lastname.length > 0 &&
                    !this.imgAvatar
                ) {
                    this.viewAvatar = true;
                    this.avatarDefault =
                        this.firstname.charAt().toUpperCase() +
                        this.lastname.charAt().toUpperCase();
                } else if (
                    this.firstname != null &&
                    this.firstname.length > 0 &&
                    !this.imgAvatar
                ) {
                    this.viewAvatar = true;
                    this.avatarDefault = this.firstname.charAt().toUpperCase();
                } else if (
                    this.lastname != null &&
                    this.lastname.length > 0 &&
                    !this.imgAvatar
                ) {
                    this.viewAvatar = true;
                    this.avatarDefault = this.lastname.charAt().toUpperCase();
                } else if (this.imgAvatar) {
                    this.viewAvatar = true;
                } else {
                    this.viewAvatar = false;
                }
            }
        },
        lastname() {
            if (!this.validimg) {
                if (
                    this.firstname != null &&
                    this.firstname.length > 0 &&
                    this.lastname != null &&
                    this.lastname.length > 0 &&
                    !this.imgAvatar
                ) {
                    this.viewAvatar = true;
                    this.avatarDefault =
                        this.firstname.charAt().toUpperCase() +
                        this.lastname.charAt().toUpperCase();
                } else if (
                    this.firstname != null &&
                    this.firstname.length > 0 &&
                    !this.imgAvatar
                ) {
                    this.viewAvatar = true;
                    this.avatarDefault = this.firstname.charAt().toUpperCase();
                } else if (
                    this.lastname != null &&
                    this.lastname.length > 0 &&
                    !this.imgAvatar
                ) {
                    this.viewAvatar = true;
                    this.avatarDefault = this.lastname.charAt().toUpperCase();
                } else if (this.imgAvatar) {
                    this.viewAvatar = true;
                } else {
                    this.viewAvatar = false;
                }
            }
        },
    },
}
</script>

<style scope="scss">
.icontri {
    position: absolute;
    top: -21px;
    left: 50%;
    display: block;
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 10px solid #a1e0ae;
    transform: translateX(-50%);
}
.prof_title {
    display: block;
    font-size: 14px;
}
.prof_title h4 {
    font-weight: 100;
    font-size: 24px;
    text-align: center;
}
.profile {
    margin-top: 60px;
}
.profile label {
    display: block;
    margin-bottom: 0.1rem;
}
span.avatarDefault {
    width: 68px;
    height: 70px;
    display: flex;
    margin: 0px auto;
    border: 1px solid #ccc;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 30px;
    font-weight: 900;
    background-color: #5ac146;
    color: #fff;
}
img#avatar {
    height: 70px;
    width: 66px;
    border: 1px solid #ccc;
    border-radius: 50%;
}
</style>
